export const QUERY_KEYS = {
	Locations: {
		Locations: "locations",
	},
	Segments: {
		Brands: "brands",
		Channels: "channels",
		Marketers: "marketers",
		States: "states",
		Branches: "branches",
	},
	Companies: {
		Companies: "companies",
		Divisions: "divisions",
		Regions: "regions",
		Markets: "markets",
		ManagementAreas: "managementAreas",
	},
	Users: {
		Users: "users",
		GetUserInfo: "userInfo",
	},
} as const;

// Backward-compatible named exports for existing imports (api/queries.ts consumers)
export const BRANCHES = QUERY_KEYS.Segments.Branches;
export const CHANNELS = QUERY_KEYS.Segments.Channels;
export const BRANDS = QUERY_KEYS.Segments.Brands;
export const MARKETERS = QUERY_KEYS.Segments.Marketers;
export const STATES = QUERY_KEYS.Segments.States;

export const GET_USER_INFO = QUERY_KEYS.Users.GetUserInfo;

export const COMPANIES = QUERY_KEYS.Companies.Companies;
export const DIVISIONS = QUERY_KEYS.Companies.Divisions;
export const REGIONS = QUERY_KEYS.Companies.Regions;
export const MARKETS = QUERY_KEYS.Companies.Markets;
export const MANAGEMENT_AREAS = QUERY_KEYS.Companies.ManagementAreas;
